import React, { useState } from 'react';
import Container from 'react-bootstrap/Container';
import Col from 'react-bootstrap/Col';
import Row from 'react-bootstrap/Row';
import { EnterActivationKey } from './EnterActivationKey';
import { SelectUnits } from './SelectUnits';
import { Licenses } from './Licenses';
import { ActivationKey } from '../types/ActivationKey';
import { License } from '../types/License';

export const ActivateLicense: React.FC = props => {
    const [stage, setStage] = useState<"EnterActivationKey" | "SelectUnits" | "Licenses">("EnterActivationKey");
    const [activationKeyCode, setActivationKeyCode] = useState<string>("");
    const [activationKey, setActivationKey] = useState<ActivationKey>();
    const [licenses, setLicenses] = useState<License[]>();
    const [licenseXml, setLicenseXml] = useState("");

    return <Container className="mb-3">
        <h4>Redeem activation key</h4>
        <Row>
            <Col>
                <p className={stage === "EnterActivationKey" ? "wizard-header-current-step" : "wizard-header"}>1. Enter activation key</p>
            </Col>
            <Col>
                <p className={stage === "SelectUnits" ? "wizard-header-current-step" : "wizard-header"}>2. Select units</p>
            </Col>
            <Col>
                <p className={stage === "Licenses" ? "wizard-header-current-step" : "wizard-header"}>3. Licenses</p>
            </Col>
        </Row>
        <Row>
            <Col>
                {stage === "EnterActivationKey" && <EnterActivationKey setStage={setStage}
                    setActivationKey={setActivationKey}
                    activationKeyCode={activationKeyCode} setActivationKeyCode={setActivationKeyCode} />}
                {stage === "SelectUnits" && <SelectUnits setStage={setStage} activationKey={activationKey} setLicenses={setLicenses} setLicenseXml={setLicenseXml} activationKeyCode={activationKeyCode} />}
                {stage === "Licenses" && activationKey && <Licenses setStage={setStage} licenses={licenses} licenseXml={licenseXml} useModuleKey={activationKey.useModuleKey} />}
            </Col>
        </Row>
    </Container>
}